
export const USE_ROSSUM_PRODUCTION = true;
export const ROSSUM_DOMAIN = USE_ROSSUM_PRODUCTION ? "elis.rossum.ai" : "elis.stg.rossum.ai";

function removeUndefinedFields(list) {
	return list.filter((a) => a !== undefined && a !== null);
}

export const ROSSUM_SCHEMA_US = [
	{
		"id": "invoice_info_section",
		"icon": null,
		"label": "Invoice details",
		"content": [
			{
				"id": "invoice_id",
				"type": "string",
				"label": "Invoice number",
				"category": "datapoint",
				"width_chars": 10,
				"default_value": null,
				"rir_field_names": [
					"invoice_id"
				]
			},
			{
				"id": "date_issue",
				"type": "date",
				"label": "Invoice Date",
				"format": "M/D/YYYY",
				"category": "datapoint",
				"width_chars": 10,
				"default_value": null,
				"rir_field_names": [
					"date_issue"
				]
			},
			{
				"id": "order_id",
				"type": "string",
				"label": "Purchase Order number",
				"category": "datapoint",
				"width_chars": 10,
				"default_value": null,
				"rir_field_names": [
					"order_id"
				]
			},
			{
				"id": "date_due",
				"type": "date",
				"label": "Due date",
				"format": "M/D/YYYY",
				"category": "datapoint",
				"width_chars": 10,
				"default_value": null,
				"rir_field_names": [
					"date_due"
				]
			}
		],
		"category": "section"
	},
	{
		"id": "vendor_section",
		"icon": null,
		"label": "Vendor & Customer",
		"content": [
			{
				"id": "sender_name",
				"type": "string",
				"label": "Vendor name",
				"category": "datapoint",
				"width_chars": 10,
				"default_value": null,
				"rir_field_names": [
					"sender_name"
				]
			},
			{
				"id": "vendor_id",
				"type": "string",
				"label": "Vendor ID",
				"category": "datapoint",
				"width_chars": 10,
				"default_value": null,
				"rir_field_names": []
			},
			{
				"id": "recipient_name",
				"type": "string",
				"label": "Customer name",
				"category": "datapoint",
				"width_chars": 10,
				"default_value": null,
				"rir_field_names": [
					"recipient_name"
				]
			},
			{
				"id": "customer_id",
				"type": "string",
				"label": "Customer ID",
				"category": "datapoint",
				"width_chars": 10,
				"default_value": null,
				"rir_field_names": [
					"customer_id"
				]
			}
		],
		"category": "section"
	},
	{
		"id": "totals_section",
		"icon": null,
		"label": "Totals and subtotals",
		"content": [
			{
				"id": "amount_total",
				"type": "number",
				"label": "Total amount",
				"category": "datapoint",
				"width_chars": 10,
				"default_value": null,
				"rir_field_names": [
					"amount_total"
				]
			},
			{
				"id": "amount_total_base",
				"type": "number",
				"label": "Subtotal",
				"category": "datapoint",
				"width_chars": 10,
				"default_value": null,
				"rir_field_names": [
					"amount_total_base"
				]
			},
			{
				"id": "amount_shipping_and_handling",
				"type": "number",
				"label": "Shipping and Handling",
				"category": "datapoint",
				"width_chars": 10,
				"default_value": null,
				"rir_field_names": []
			}
		],
		"category": "section"
	},
	{
		"id": "bank_details_section",
		"icon": null,
		"label": "Bank details",
		"content": [
			{
				"id": "payment_method",
				"type": "string",
				"label": "Payment method",
				"category": "datapoint",
				"width_chars": 10,
				"default_value": null,
				"rir_field_names": []
			},
			{
				"id": "payment_id",
				"type": "string",
				"label": "Payment ID",
				"category": "datapoint",
				"width_chars": 10,
				"default_value": null,
				"rir_field_names": []
			},
			{
				"id": "bank_name",
				"type": "string",
				"label": "Bank name",
				"category": "datapoint",
				"width_chars": 10,
				"default_value": null,
				"rir_field_names": []
			},
			{
				"id": "bank_num",
				"type": "string",
				"label": "Account number",
				"category": "datapoint",
				"width_chars": 10,
				"default_value": null,
				"rir_field_names": [
					"bank_num"
				]
			},
			{
				"id": "routing",
				"type": "string",
				"label": "Routing",
				"category": "datapoint",
				"width_chars": 10,
				"default_value": null,
				"rir_field_names": []
			}
		],
		"category": "section"
	},
	{
		"id": "line_items_section",
		"icon": null,
		"label": "Items",
		"content": [
			{
				"id": "line_items",
				"label": "Items",
				"content": {
					"id": "line_item",
					"label": "Items",
					"content": [
						{
							"id": "item_desc",
							"type": "string",
							"label": "Item",
							"category": "datapoint",
							"width_chars": 10,
							"default_value": null,
							"rir_field_names": []
						},
						{
							"id": "item_quantity",
							"type": "number",
							"label": "Quantity",
							"category": "datapoint",
							"width_chars": 10,
							"default_value": null,
							"rir_field_names": []
						},
						{
							"id": "item_unit_price",
							"type": "number",
							"label": "Unit price",
							"category": "datapoint",
							"width_chars": 10,
							"default_value": null,
							"rir_field_names": []
						},
						{
							"id": "item_price",
							"type": "number",
							"label": "Subtotal",
							"category": "datapoint",
							"width_chars": 10,
							"default_value": null,
							"rir_field_names": []
						}
					],
					"category": "tuple",
					"rir_field_names": []
				},
				"category": "multivalue",
				"max_occurrences": null,
				"min_occurrences": null
			},
		],
		"category": "section"
	}
];

export function getRossumSchemaCZ({useAccountingDate, isIncomingInvoice, useBankAccount, showDocumentType, showOrderId, accountingDateAsIssueDate, receivingDateIsIssueDate, detectLineItems, showDueDate, useItems, useStock, defaultStockItem, isVatPayer, showIban, showSpecSym, isIDoklad, isPohoda, is6k, isFlexiBee, isHelios, isAbraGen, showVarSym, showDUZPUcto, isSlovakia, showPohodaVATClassification, type, showMyINorVATID, isSalesOrders, isIssuedOrders}) {
	let date_issue = "Datum vystavení";
	let date_receiving = "Přijato";
	let date_uzp = "DÚZP (Datum KH)";
	let date_accounting = "Datum zaúčtování";
	let date_uzpUcto = "DÚZP (uplatnit)";
	let date_due = "Datum splatnosti";
	let showPrivateNote = true;

	if (!isIncomingInvoice) {
		date_uzp = "DÚZP";
	}


	if (isPohoda) {
		if (isSlovakia) {
			if (isIncomingInvoice) {
				date_receiving = "Dátum zápisu";
				date_uzp = "Dátum dodania";
				date_uzpUcto = "Dátum odpočtu";
				date_accounting = "Dátum úč.prípadu";
				date_due = "Dátum splatnosti";
			} else {
				date_issue = "Dátum vystavenia";
				date_uzp = "Dátum daň.povin.";
				date_accounting = "Dátum úč.prípadu";
				date_due = "Dátum splatnosti";
			}
		} else {
			date_receiving = "Datum zápisu";
			date_accounting = "Datum odp./dor.";
		}
	}

	if (isIDoklad) {
		date_accounting = "Datum přijetí";
	}

	if (isHelios) {
		date_receiving = "Datum doručení";
		date_accounting = "Datum případu";
	}

	if (isFlexiBee) {
		if (isIncomingInvoice) {
			date_uzp = "DÚZP (původní)";
		}
	}

	if (isAbraGen) {
		showPrivateNote = false;
		date_uzpUcto = "Datum uplatnení odpočtu";
		date_uzp = "Datum plnění";
	}

	let useIbanInsteadOfAccount = false;
	if (isSlovakia && isPohoda) {
		useIbanInsteadOfAccount = true;
	}

	let documentTypes = [
		{
			"value": 'tax_invoice',
			"label": isIncomingInvoice ? 'Faktura přijatá' : 'Faktura vydaná',
		},
		{
			"value": 'credit_note',
			"label": 'Dobropis',
		},
		{
			"value": 'debit_note',
			"label": 'Vrubopis',
		},
		// {
		// 	"value": 'issued_invoice',
		// 	"label": 'Faktura vydaná',
		// },
	];

	if (isPohoda) {
		if (isSlovakia) {
			documentTypes = [
				{
					"value": 'tax_invoice',
					"label": isIncomingInvoice ? 'Faktura přijatá' : 'Faktura vydaná',
				},
				{
					"value": 'proforma',
					"label": 'Zálohová faktura (proforma)',
				},
				{
					"value": 'credit_note',
					"label": 'Ťarchopis',
				},
			];
		} else {
			documentTypes = [
				{
					"value": 'tax_invoice',
					"label": isIncomingInvoice ? 'Faktura přijatá' : 'Faktura vydaná',
				},
				{
					"value": 'proforma',
					"label": 'Zálohová faktura (proforma)',
				},
				{
					"value": 'credit_note',
					"label": 'Opravný daňový doklad',
				},
			];
		}
	} else if (isAbraGen) {
		documentTypes = [
			{
				"value": 'tax_invoice',
				"label": isIncomingInvoice ? 'Faktura přijatá' : 'Faktura vydaná',
			},
			{
				"value": 'proforma',
				"label": isIncomingInvoice ? 'Zálohová faktura přijatá' : 'Zálohová faktura vydaná',
			},
			{
				"value": 'credit_note',
				"label": isIncomingInvoice ? 'Dobropis faktury přijaté' : 'Dobropis faktury vydané',
			},
		];
	}

	return removeUndefinedFields([
	{
		"id": "invoice_info_section",
		"icon": null,
		"label": "Základní informace",
		"children": removeUndefinedFields([(showDocumentType ? {
				"id": "documentType",
				"type": "enum",
				"label": "Typ faktury",
				"category": "datapoint",
				"width_chars": 10,
				"default_value": "tax_invoice",
				"rir_field_names": [
					"invoice_type"
				],
				"constraints": {
					required: false
				},
				"options": documentTypes
			} : undefined), {
			"id": "internal_id",
			"type": "string",
			"label": "Interní číslo dokladu",
			"category": "datapoint",
			"width_chars": 15,
			"default_value": null,
			"rir_field_names": [],
			"constraints": {
				required: false
			},
			"hidden": true,
		}, {
			"id": "terms",
			"type": "string",
			"label": "Dodací podmínky",
			"category": "datapoint",
			"width_chars": 15,
			"default_value": null,
			"rir_field_names": ["terms"],
			"constraints": {
				required: false
			},
			"hidden": true,
		}, {
			"id": "invoice_id",
			"type": "string",
			"label": "Číslo dokladu",
			"category": "datapoint",
			"width_chars": 15,
			"default_value": null,
			"rir_field_names": ["invoice_id", "var_sym"]
		}, (showOrderId ? {
			"id": "order_id",
			"type": "string",
			"label": "Číslo objednávky",
			"category": "datapoint",
			"width_chars": 15,
			"default_value": null,
			"rir_field_names": ["order_id"],
			"constraints": {
				required: false
			}
		} : undefined), (isIncomingInvoice === false || isHelios || is6k ? {
			"id": "date_issue",
			"type": "date",
			"label": date_issue,
			"format": "D. M. YYYY",
			"category": "datapoint",
			"width_chars": 13,
			"default_value": null,
			"rir_field_names": ["date_issue", "date_uzp"],
		} : undefined), (isIncomingInvoice ? {
			"id": "date_receiving",
			"type": "date",
			"label": date_receiving,
			"format": "D. M. YYYY",
			"category": "datapoint",
			"width_chars": 13,
			"default_value": null,

			"rir_field_names": receivingDateIsIssueDate ? ["date_issue", "date_uzp"] : [],
			"constraints": {
				required: false
			},
		} : undefined), (showDueDate ? {
			"id": "date_due",
			"type": "date",
			"label": date_due,
			"format": "D. M. YYYY",
			"category": "datapoint",
			"width_chars": 13,
			"default_value": null,
			"rir_field_names": ["date_due"],
			"constraints": {
				required: false
			}
		} : undefined), (isVatPayer && !isSalesOrders && !isIssuedOrders ? {
			"id": "date_uzp",
			"type": "date",
			"label": date_uzp,
			"format": "D. M. YYYY",
			"category": "datapoint",
			"width_chars": 13,
			"default_value": null,
			"rir_field_names": isIncomingInvoice ? ["date_uzp", "date_issue"] : ["date_uzp"],
			"constraints": {
				required: false
			}
		} : undefined), (isVatPayer && showDUZPUcto && isIncomingInvoice ? {
			"id": "date_uzpUcto",
			"type": "date",
			"label": date_uzpUcto,
			"format": "D. M. YYYY",
			"category": "datapoint",
			"width_chars": 13,
			"default_value": null,
			"rir_field_names": accountingDateAsIssueDate ? ["date_issue"] : [],
			"constraints": {
				required: false
			}
		} : undefined), (useAccountingDate ? {
			"id": "date_accounting",
			"type": "date",
			"label": date_accounting,
			"format": "D. M. YYYY",
			"category": "datapoint",
			"width_chars": 13,
			"default_value": null,
			"rir_field_names": accountingDateAsIssueDate ? (
				isSlovakia ?
					["date_uzp", "date_issue"]
					:
					["date_issue", "date_uzp"]
				) : [],
			"constraints": {
				required: false
			}
		} : undefined),
		// {
		// 	"id": "const_sym",
		// 	"type": "string",
		// 	"label": "Konstantní symbol",
		// 	"category": "datapoint",
		// 	"width_chars": 10,
		// 	"default_value": null,
		// 	"rir_field_names": ["const_sym"],
		// 	"constraints": {
		// 		required: false
		// 	}
		// },
		(showVarSym ? {
			"id": "var_sym",
			"type": "string",
			"label": "Variabilní symbol",
			"category": "datapoint",
			"width_chars": 15,
			"default_value": null,
			"rir_field_names": ["var_sym", "invoice_id"],
			"constraints": {
				required: false
			}
		} : undefined), (useBankAccount ? {
			"id": "account_num",
			"type": "string",
			"label": "Číslo účtu",
			"category": "datapoint",
			"width_chars": 15,
			"default_value": null,
			"rir_field_names": useIbanInsteadOfAccount ? ["iban"] : ["account_num"],
			"constraints": {
				required: false
			}
		} : undefined), (useBankAccount ? {
			"id": "bank_num",
			"type": "string",
			"label": "K\u00f3d banky",
			"category": "datapoint",
			"width_chars": 15,
			"default_value": null,
			"rir_field_names": isSlovakia ? ["bic"] : ["bank_num"],
			"constraints": {
				required: false
			}
		} : undefined), (showIban && useBankAccount && !useIbanInsteadOfAccount ? {
			"id": "iban",
			"type": "string",
			"label": "IBAN",
			"category": "datapoint",
			"width_chars": 25,
			"default_value": null,
			"rir_field_names": ["iban"],
			"constraints": {
				required: false
			}
		} : undefined), (showIban && useBankAccount && !useIbanInsteadOfAccount ? {
			"id": "bic",
			"type": "string",
			"label": "BIC/SWIFT",
			"category": "datapoint",
			"width_chars": 10,
			"default_value": null,
			"rir_field_names": ["bic"],
			"constraints": {
				required: false
			}
		} : undefined), (showSpecSym && useBankAccount ? {
			"id": "spec_sym",
			"type": "string",
			"label": "Specifický symbol",
			"category": "datapoint",
			"width_chars": 10,
			"default_value": null,
			"rir_field_names": ["spec_sym"],
			"constraints": {
				required: false
			}
		} : undefined),
		{
			"id": "currency",
			"type": "string",
			"label": "M\u011bna",
			"category": "datapoint",
			"width_chars": 3,
			"default_value": null,
			"rir_field_names": ["currency"],
			"constraints": {
				required: false
			}
		},
		{
			"id": "description",
			"type": "string",
			"label": "Popis",
			"category": "datapoint",
			"width_chars": 100,
			"default_value": null,
			"rir_field_names": ["internal_notes"],
			"constraints": {
				required: false
			}
		}, (showPrivateNote ? {
			"id": "notes",
			"type": "string",
			"label": "Poznámky (interní)",
			"category": "datapoint",
			"width_chars": 1000,
			"default_value": null,
			"rir_field_names": [],
			"constraints": {
				required: false
			}
		} : undefined), {
			"id": "type",
			"type": "string",
			"label": "Typ",
			"category": "datapoint",
			"width_chars": 10,
			"default_value": type,
			"rir_field_names": [
			],
			"constraints": {
				required: false
			},
			"hidden": true,
		}]),
		"category": "section"
	}, {
		"id": "amounts_section",
		"icon": null,
		"label": isVatPayer ? "Částky a DPH" : "Částky",
		"children": removeUndefinedFields([
		(isVatPayer ? {
			"id": "vat_details",
			"label": "Rekapitulace DPH",
			"children": {
				"id": "vat_detail",
				"label": "Rekapitulace DPH",
				"children": [{
					"id": "vat_detail_rate",
					"type": "number",
					"label": "Sazba DPH",
					"category": "datapoint",
					"width_chars": 10,
					"default_value": null,
					"rir_field_names": ["tax_detail_rate"],
					"constraints": {
						required: false
					},
					"format": "# ##0.#"
				}, {
					"id": "vat_detail_base",
					"type": "number",
					"label": "Základ DPH",
					"category": "datapoint",
					"width_chars": 10,
					"default_value": null,
					"rir_field_names": ["tax_detail_base"],
					"constraints": {
						required: false
					},
					"format": "# ##0.#"
				}, {
					"id": "vat_detail_tax",
					"type": "number",
					"label": "Částka DPH",
					"category": "datapoint",
					"width_chars": 10,
					"default_value": null,
					"rir_field_names": ["tax_detail_tax"],
					"constraints": {
						required: false
					},
					"format": "# ##0.#"
				}/*, {
					"id": "vat_detail_total",
					"type": "number",
					"label": "Celkem s DPH",
					"category": "datapoint",
					"width_chars": 10,
					"default_value": null,
					"rir_field_names": ["vat_detail_total"],
					"constraints": {
						required: false
					},
					"format": "# ##0.#"
				}*/],
				"category": "tuple",
				"rir_field_names": ["tax_details"]
			},
			"category": "multivalue",
			"max_occurrences": 4,
			"min_occurrences": null
		} : undefined),
		(isVatPayer ? {
			"id": "amount_total_base",
			"type": "number",
			"label": "Celkem bez DPH",
			"category": "datapoint",
			"width_chars": 10,
			"default_value": null,
			"rir_field_names": ["amount_total_base"],
			"format": "# ##0.#",
			"constraints": {
				required: false
			}
		} : undefined), (isVatPayer ? {
			"id": "amount_total_tax",
			"type": "number",
			"label": "Celkem DPH",
			"category": "datapoint",
			"width_chars": 10,
			"default_value": null,
			"rir_field_names": ["amount_total_tax"],
			"format": "# ##0.#",
			"constraints": {
				required: false
			}
		} : undefined), (isVatPayer || useItems ? {
			"id": "amount_rounding",
			"type": "number",
			"label": "Zaokrouhlení",
			"category": "datapoint",
			"width_chars": 10,
			"default_value": "0",
			"rir_field_names": ["amount_rounding"],
			"constraints": {
				required: false
			},
			"format": "# ##0.#"
		} : undefined), {
			"id": "amount_total",
			"type": "number",
			"label": isVatPayer ? "Celkem s DPH" : "Celkem",
			"category": "datapoint",
			"width_chars": 10,
			"default_value": null,
			"rir_field_names": ["amount_due", "amount_total"],
			"format": "# ##0.#",
			"constraints": {
				required: false
			}
		},
		// {
		// 	"id": "amount_paid",
		// 	"type": "number",
		// 	"label": "Zaplaceno",
		// 	"category": "datapoint",
		// 	"width_chars": 10,
		// 	"default_value": 0,
		// 	"rir_field_names": ["amount_paid"],
		// 	"constraints": {
		// 		required: false
		// 	}
		// }, {
		// 	"id": "amount_due",
		// 	"type": "number",
		// 	"label": "K úhradě",
		// 	"category": "datapoint",
		// 	"width_chars": 10,
		// 	"default_value": null,
		// 	"rir_field_names": ["amount_due"],
		// 	"constraints": {
		// 		required: false
		// 	}
		// },
		]),
		"category": "section"
	}, (useItems ? {
		"id": "line_items_section",
		"icon": null,
		"label": "Položky dokladu",
		"children": [{
			"id": "line_items",
			"label": "Položky dokladu",
			"children": {
				"id": "line_item",
				"label": "Položka dokladu",
				"children": removeUndefinedFields([(useStock ? {
					"id": "itemType",
					"type": "enum",
					"label": "Typ",
					"category": "datapoint",
					"width_chars": 3,
					"default_value": defaultStockItem ? "stock" : "text",
					"constraints": {
						required: false
					},
					"rir_field_names": [],
					"options": [
						{
							"value": 'stock',
							"label": 'Sklad',
						},
						{
							"value": 'text',
							"label": 'Text',
						},
						{
							"value": 'create',
							"label": 'Založit',
						},
					]
				} : undefined), {
					"id": "item_description",
					"type": "string",
					"label": "Název",
					"category": "datapoint",
					"width_chars": 200,
					"default_value": null,
					"constraints": {
						required: false
					},
					"rir_field_names": detectLineItems ? ["table_column_description"] : []
				}, {
					"id": "item_code",
					"type": "string",
					"label": "Kód zboží",
					"category": "datapoint",
					"width_chars": 20,
					"default_value": defaultStockItem || '',
					"constraints": {
						required: false
					},
					"rir_field_names": detectLineItems ? ["table_column_code"] : [],
				}, {
					"id": "item_quantity",
					"type": "number",
					"label": "Množství",
					"category": "datapoint",
					"width_chars": 10,
					"default_value": "1",
					"rir_field_names": detectLineItems ? ["table_column_quantity"] : [],
					"constraints": {
						required: false
					},
					"format": "# ##0.#",
				}, {
					"id": "item_net_unit_price",
					"type": "number",
					"label": isVatPayer ? "Cena za MJ bez DPH" : "Cena za MJ",
					"category": "datapoint",
					"width_chars": 10,
					"default_value": null,
					"rir_field_names": detectLineItems ? ["table_column_amount_base"] : [],
					"constraints": {
						required: false
					},
					"format": "# ##0.#"
				}, (isVatPayer ? {
					"id": "item_net_unit_price_with_vat",
					"type": "number",
					"label": "Cena za MJ s DPH",
					"category": "datapoint",
					"width_chars": 10,
					"default_value": null,
					"rir_field_names": detectLineItems ? ["table_column_amount"] : [],
					"constraints": {
						required: false
					},
					"format": "# ##0.#"
				} : null), (isVatPayer ? {
					"id": "item_vat_rate",
					"type": "number",
					"label": "Sazba DPH",
					"category": "datapoint",
					"width_chars": 3,
					"default_value": null,
					"rir_field_names": detectLineItems ? ["table_column_rate"] : [],
					"constraints": {
						required: false
					},
					"format": "# ##0.#"
				} : { // pseudo VAT rate to compute values without VAT
					"id": "item_vat_rate",
					"type": "number",
					"label": "Sazba DPH",
					"category": "datapoint",
					"width_chars": 3,
					"default_value": "0",
					"rir_field_names": [],
					"constraints": {
						required: false
					},
					"hidden": true,
					"format": "# ##0.#"
				}), {
					"id": "item_total_price",
					"type": "number",
					"label": isVatPayer ? "Celkem bez DPH" : "Celkem",
					"category": "datapoint",
					"width_chars": 10,
					"default_value": null,
					"rir_field_names": detectLineItems ? ["table_column_amount_total_base"] : [],
					"constraints": {
						required: false
					},
					"format": "# ##0.#"
				}, (isVatPayer ? {
					"id": "item_total_vat",
					"type": "number",
					"label": "DPH",
					"category": "datapoint",
					"width_chars": 10,
					"default_value": null,
					"rir_field_names": detectLineItems ? ["table_column_tax"] : [],
					"constraints": {
						required: false
					},
					"format": "# ##0.#"
				} : null), (isVatPayer ? {
					"id": "item_total_with_vat",
					"type": "number",
					"label": "Celkem s DPH",
					"category": "datapoint",
					"width_chars": 10,
					"default_value": null,
					"rir_field_names": detectLineItems ? ["table_column_amount_total"] : [],
					"constraints": {
						required: false
					},
					"format": "# ##0.#"
				} : null)]),
				"category": "tuple",
				"rir_field_names": []
			},
			"category": "multivalue",
			"max_occurrences": null,
			"min_occurrences": null
		}, /*{
			"id": "generate_rounding",
			"type": "enum",
			"label": "Generovat zaokrouhlení",
			"category": "datapoint",
			"width_chars": 10,
			"default_value": 'false',
			"rir_field_names": [],
			"constraints": {
				required: false
			},
			"options": [
				{
					"value": 'false',
					"label": 'Ne',
				},
				{
					"value": 'true',
					"label": 'Ano',
				},
			]
		}*/],
		"category": "section"
	} : undefined), {
		"id": "vendor_section",
		"icon": null,
		"label": "Dodavatel a Zákazník",
		"children": isIncomingInvoice || isSalesOrders ? removeUndefinedFields([{
			"id": "sender_name",
			"type": "string",
			"label": "Jm\u00e9no dodavatele",
			"category": "datapoint",
			"width_chars": 100,
			"default_value": null,
			"rir_field_names": ["sender_name"]
		}, {
			"id": "sender_ic",
			"type": "string",
			"label": "IČ dodavatele",
			"category": "datapoint",
			"width_chars": 15,
			"default_value": null,
			"rir_field_names": ["sender_ic"],
			"constraints": {
				required: false
			}
		}, (isSlovakia ? {
			"id": "sender_dic",
			"type": "string",
			"label": "DIČ dodavatele",
			"category": "datapoint",
			"width_chars": 15,
			"default_value": null,
			"rir_field_names": ["sender_dic"],
			"constraints": {
				required: false
			}
		} : undefined), {
			"id": "sender_vat_id",
			"type": "string",
			"label": isSlovakia ? "IČ-DPH dodavatele" : "DIČ dodavatele",
			"category": "datapoint",
			"width_chars": 15,
			"default_value": null,
			"rir_field_names": isSlovakia ? ["sender_vat_id"] : ["sender_vat_id", "sender_dic"],
			"constraints": {
				required: false
			}
		}, {
			"id": "sender_address",
			"type": "string",
			"label": "Adresa dodavatele",
			"category": "datapoint",
			"width_chars": 100,
			"default_value": null,
			"rir_field_names": ["sender_address"],
			"constraints": {
				required: false
			}
		},
		{
			"id": "sender_email",
			"type": "string",
			"label": "E-mail dodavatele",
			"category": "datapoint",
			"width_chars": 100,
			"default_value": null,
			"rir_field_names": ["sender_email"],
			"hidden": true,
			"constraints": {
				required: false
			}

		}, (showMyINorVATID ? {
			"id": "recipient_ic",
			"type": "string",
			"label": "Kontrolní IČ zákazníka",
			"category": "datapoint",
			"width_chars": 15,
			"default_value": null,
			"rir_field_names": ["recipient_ic"],
			"constraints": {
				required: false
			}
		} : undefined), (showMyINorVATID ? {
			"id": "recipient_vat_id",
			"type": "string",
			"label": isSlovakia ? "Kontrolní IČ-DPH zákazníka" : "Kontrolní DIČ zákazníka",
			"category": "datapoint",
			"width_chars": 15,
			"default_value": null,
			"rir_field_names": isSlovakia ? ["recipient_vat_id"] : ["recipient_vat_id", "recipient_dic"],
			"constraints": {
				required: false
			}
		} : undefined)]) : removeUndefinedFields([{
			"id": "recipient_name",
			"type": "string",
			"label": "Jm\u00e9no zákazníka",
			"category": "datapoint",
			"width_chars": 100,
			"default_value": null,
			"rir_field_names": ["recipient_name"]
		}, {
			"id": "recipient_ic",
			"type": "string",
			"label": "IČ zákazníka",
			"category": "datapoint",
			"width_chars": 15,
			"default_value": null,
			"rir_field_names": ["recipient_ic"],
			"constraints": {
				required: false
			}
		}, {
			"id": "recipient_dic",
			"type": "string",
			"label": isSlovakia ? "IČ-DPH zákazníka" : "DIČ zákazníka",
			"category": "datapoint",
			"width_chars": 15,
			"default_value": null,
			"rir_field_names": isSlovakia ? ["recipient_vat_id"] : ["recipient_vat_id", "recipient_dic"],
			"constraints": {
				required: false
			}
		}, {
			"id": "recipient_address",
			"type": "string",
			"label": "Adresa zákazníka",
			"category": "datapoint",
			"width_chars": 100,
			"default_value": null,
			"rir_field_names": ["recipient_address"],
			"constraints": {
				required: false
			}
		}, (showMyINorVATID ? {
			"id": "sender_ic",
			"type": "string",
			"label": "Kontrolní IČ dodavatele",
			"category": "datapoint",
			"width_chars": 15,
			"default_value": null,
			"rir_field_names": ["sender_ic"],
			"constraints": {
				required: false
			}
		} : undefined), (showMyINorVATID ? {
			"id": "sender_dic",
			"type": "string",
			"label": isSlovakia ? "Kontrolní IČ-DPH dodavatele" : "Kontrolní DIČ dodavatele",
			"category": "datapoint",
			"width_chars": 15,
			"default_value": null,
			"rir_field_names": isSlovakia ? ["sender_vat_id"] : ["sender_vat_id", "sender_dic"],
			"constraints": {
				required: false
			}
		} : undefined)]),
		"category": "section"
	},
	]);
}

export const ROSSUM_GROUPS = {
	SETTINGS: 'SETTINGS',
	INVOICING: 'INVOICING'
};
